import InspectionStatus from './InspectionStatus';

export default InspectionStatus;
